/**
 * Created by PuTi(编程即菩提) 9/1/17.
 */

var nb = require('../nb');
var Model = nb.define({
    parent: require('../../nb/bs3/js/model/modal/Confirm'),
    mapping: {
    },
    method: {
        init: function () {

            this.setOpts({
                btnCancel: {
                    text: '取消'
                },
                btnConfirm: {
                    text: '确认'
                }
            });
            this.onChange('confirm',function (inEvent) {
                var fn = this.get('affirm');
                var opts={};
                if(fn){
                    var scope = this.get('scope');
                    if(this.get('id')){
                        opts['id']=this.get('id');
                    }
                    if(this.get('favId')){
                        opts['favId']=this.get('favId');
                    }
                    opts['type'] = this.get('type');
                    fn.call(scope,opts)
                }
            },this)
        }
    }
});
var model = new Model;
module.exports = model;


//////////////////
// WEBPACK FOOTER
// ../src/js/model/Modal.js
// module id = 47
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32